(function () {
  var STORAGE_KEY = 'coca_wishlist_handles_v1';
  var BTN_SELECTOR = '.js-coca-wishlist-btn';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return typeof item === 'string' && item.trim() !== '';
      });
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    var unique = Array.from(new Set(items));
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    } catch (e) {
      return unique;
    }
    window.dispatchEvent(
      new CustomEvent('coca:wishlist:change', {
        detail: { items: unique }
      })
    );
    return unique;
  }

  function isWishlisted(handle) {
    return readWishlist().indexOf(handle) > -1;
  }

  function toggleWishlist(handle) {
    if (!handle) return readWishlist();
    var items = readWishlist();
    var index = items.indexOf(handle);
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.unshift(handle);
    }
    return writeWishlist(items);
  }

  function setButtonState(button, active) {
    // button.classList.toggle('is-active', active);
    button.classList.toggle('coca-product-card__wishlist--active', active);
    button.classList.toggle('coca-product__wishlist--active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function refreshButtons(root) {
    var scope = root || document;
    var items = readWishlist();
    scope.querySelectorAll(BTN_SELECTOR).forEach(function (button) {
      var handle = (button.getAttribute('data-product-handle') || '').trim();
      if (!handle) return;
      setButtonState(button, items.indexOf(handle) > -1);
    });
  }

  function isNumericId(str) {
    return /^\d+$/.test(str);
  }

  async function resolveHandle(handleOrId) {
    if (!isNumericId(handleOrId)) return handleOrId;
    var response = await fetch('/products/' + handleOrId + '.js');
    if (!response.ok) return null;
    var data = await response.json();
    return data.handle || null;
  }

  async function fetchCardHtml(handleOrId) {
    var handle = await resolveHandle(handleOrId);
    if (!handle) return null;
    var response = await fetch(
      '/products/' + encodeURIComponent(handle) + '?sections=coca-wishlist-card'
    );
    if (!response.ok) throw new Error('product fetch failed: ' + handle);
    var data = await response.json();
    return data['coca-wishlist-card'] || null;
  }

  async function renderWishlistPage() {
    var page = document.querySelector('[data-coca-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var countEl = page.querySelector('[data-wishlist-count]');
    if (!grid || !empty) return;

    if (countEl) countEl.textContent = '0';

    var handles = readWishlist();

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.innerHTML = '<p class="coca-wishlist-page__loading">Loading...</p>';

    var htmlParts = await Promise.all(
      handles.map(function (handle) {
        return fetchCardHtml(handle).catch(function () {
          return null;
        });
      })
    );

    var validParts = htmlParts.filter(Boolean);
    if (!validParts.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    if (countEl) countEl.textContent = String(handles.length);

    grid.innerHTML = validParts.join('');
    refreshButtons(page);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(BTN_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = (button.getAttribute('data-product-handle') || '').trim();
    if (!handle) return;

    var items = toggleWishlist(handle);
    var active = items.indexOf(handle) > -1;
    setButtonState(button, active);
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons(document);
    renderWishlistPage();
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    refreshButtons(document);
    renderWishlistPage();
  });

  window.addEventListener('coca:wishlist:change', function () {
    refreshButtons(document);
    renderWishlistPage();
  });

  window.CocaWishlist = {
    key: STORAGE_KEY,
    read: readWishlist,
    write: writeWishlist,
    toggle: toggleWishlist,
    has: isWishlisted,
    refreshButtons: refreshButtons
  };
})();
